import { MutationStatus, useMutation } from '@tanstack/react-query';
import postTinkInquiriesApiCall, {
  PostTinkInquiriesPayload,
} from 'api/calls/postTinkInquiriesApiCall';

interface UseTinkInquiriesMutation {
  status: MutationStatus;
  postTinkInquiries: (payload: PostTinkInquiriesPayload) => void;
}

const useTinkInquiriesMutation = (): UseTinkInquiriesMutation => {
  const mutation = useMutation((payload: PostTinkInquiriesPayload) =>
    postTinkInquiriesApiCall(payload),
  );

  return {
    status: mutation.status,
    postTinkInquiries: mutation.mutateAsync,
  };
};

export default useTinkInquiriesMutation;
